import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LogoIntro from "@/components/LogoIntro";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import BeforeAfter from "@/components/BeforeAfter";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import { Impressum, Datenschutz, AGB } from "@/pages/Legal";

const Home = () => {
  return (
    <div data-testid="home-page" className="bg-white">
      <LogoIntro />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <About />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
